module.exports = __webpack_public_path__ + "img/footer_party.874abe92.png";